import React, { createContext, PropsWithChildren } from "react";
import {
  IListContext,
  initialContext,
  ListProvider,
} from "@common/components/ListDetailViews/ListView/ListContext";
import { Log } from "@services/audit/types";

export const AuditListContext =
  createContext<IListContext<Log>>(initialContext);

export const AuditProvider = (props: PropsWithChildren<{}>) => (
  <ListProvider
    context={AuditListContext}
    initialState={{
      ...initialContext,
      sort: { column: "created", direction: "desc" },
    }}
  >
    {props.children}
  </ListProvider>
);
